import * as React from 'react';

import {
  Lang,
  Colors,
  Breakpoint,

  counter,
  useDimensions,
  useCurrencyFormat,

  Text,
} from '@bluecurrent/web-component-lib';

import Setup from '../../config/setup';

export default function hasAlreadyReserved(props) {
  const { _ } = Lang.useTranslation();
  const size = useDimensions();
  const currencyFormat = useCurrencyFormat('nl');

  return (
    <>
      <div
        style={{
          height: 'auto',
          width: '100%',
          backgroundColor: Colors.BLUE,
          paddingTop: 25,
          paddingBottom: 25,
          paddingLeft: size.width < 830 ? '3%' : '8%',
          paddingRight: size.width < 830 ? '3%' : '8%',
          borderBottomLeftRadius: size.width < Breakpoint.xxl ? 0 : 10,
          borderBottomRightRadius: size.width < Breakpoint.xxl ? 0 : 10,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: '100%',
            height: 'auto',
            marginTop: -7,
          }}
        >
          <Text
            fontSize="1.8em"
            fontWeight={500}
            textAlign="center"
            color={Colors.WHITE}
            lineHeight={1.2}
          >
            {
              Setup.SUCCESS
                ? _('invest.success', { amount: currencyFormat(counter(0, parseInt(1400000, 10), 2), 'EUR'), ns: 'branding' })
                : _('invest.hasAlreadyReserved', { amount: currencyFormat(counter(0, parseInt(props.amount, 10), 2), 'EUR'), ns: 'branding' })
              }
          </Text>
        </div>
      </div>
      {
        !Setup.SUCCESS && (
          <div
            style={{
              height: 'auto',
              width: '100%',
              paddingRight: 15,
              paddingTop: size.width < 830 ? 0 : 5,
            }}
          >
            <Text
              fontSize="0.9em"
              textAlign="right"
              color={size.width < 830 ? Colors.WHITE : Colors.DARK_WHITE}
              fontWeight={100}
            >
              {`${_('lastUpdate', { ns: 'ui' })}: ${props.lastUpdate}`}
            </Text>
          </div>
        )
      }
    </>
  );
}
